import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const textFieldV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate text field element to v2',
  run: (props: PartialPropsOf<'textField'>): void => {
    if (typeof props.content?.title?.align === 'string') {
      props.content.title.align = { horizontal: props.content.title.align };
    }
    migrateFontBoldStyleToFontWeightMutably(props?.style?.inputFont);
  },
};
